import React, { useEffect } from 'react';
import { useScans } from '../../hooks/useScans';
interface GoogleReviewTriggerProps {
  userId: string | undefined;
}
/**
 * Invisible component that watches the user's scan count and dispatches
 * a 'scanCompleted' event whenever a new completed scan is detected.
 * The GoogleReviewContext listens for this event and shows the review modal
 * after the threshold is reached.
 */
export function GoogleReviewTrigger({
  userId
}: GoogleReviewTriggerProps) {
  const {
    scans
  } = useScans(userId);
  useEffect(() => {
    if (!userId) return;
    const completedCount = scans.filter(s => s.status === 'completed').length;
    const storageKey = `google_review_last_completed_${userId}`;
    const previousCount = parseInt(localStorage.getItem(storageKey) || '0', 10);
    if (completedCount > previousCount) {
      // Dispatch one event per newly completed scan
      const newScans = completedCount - previousCount;
      for (let i = 0; i < newScans; i++) {
        window.dispatchEvent(new Event('scanCompleted'));
      }
      localStorage.setItem(storageKey, String(completedCount));
    }
  }, [scans, userId]);
  return null;
}